import React from "react";
import FileViewer from "react-file-viewer";

const DocumentViewer = ({ fileUrl, fileType }) => {
  const onError = (e) => {
    console.error("Error loading document:", e);
  };

  return (
    <div style={{ width: "100%", height: "500px" }}>
      <FileViewer
        fileType={fileType}
        filePath={fileUrl}
        onError={onError}
      />
    </div>
  );
};

export default DocumentViewer;
